var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8 3A13.16 13.16 0 0 0 24 8.62a13.2 13.2 0 0 0-24 7.57c0 6.25 3.33 12.53 9.9 18.66a92 92 0 0 0 13.59 10L24 45l.52-.15a105.18 105.18 0 0 0 13.57-10C44.85 28.73 48 22.8 48 16.19A13.21 13.21 0 0 0 34.8 3Zm1.94 30.38A103.06 103.06 0 0 1 24 42.82a89.85 89.85 0 0 1-12.73-9.43C5.12 27.65 2 21.86 2 16.19A11.19 11.19 0 0 1 23.11 11l.89 1.69.89-1.69A11.19 11.19 0 0 1 46 16.19c0 6-2.94 11.47-9.25 17.19Z"
  })));
};
export default SvgHeart;